import { render, staticRenderFns } from "./ExibirComentario.vue?vue&type=template&id=78948e7a&scoped=true&"
import script from "./ExibirComentario.vue?vue&type=script&lang=js&"
export * from "./ExibirComentario.vue?vue&type=script&lang=js&"
import style0 from "./ExibirComentario.vue?vue&type=style&index=0&id=78948e7a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78948e7a",
  null
  
)

export default component.exports